(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignQuestionnaireAddController', Controller);

    Controller.$inject = ['$scope', '$state', 'oddCampaignService'];

    function Controller($scope, $state, oddCampaignService) {

        // Get Questionnaire Templates
        oddCampaignService.getAvailableQuestionnaires($scope.campaign.ODDBusinessUnitID).then(function (qTemplates) {
            $scope.questionnaireTemplates = _.differenceBy(qTemplates, $scope.campaign.ODDCampaignQuestionnaires, 'ODDQuestionnaireID');
        });

        $scope.addQuestionnaire = function (qTemplate) {
            var campQuestionnaireToCreate = {
                ODDQuestionnaireID: qTemplate.ODDQuestionnaireID,
                ODDCampaignID: $scope.campaign.ODDCampaignID
            };

            oddCampaignService.createQuestionnaire($scope.campaign.ODDBusinessUnitID, $scope.campaign.ODDExternalPartyID,
                    $scope.campaign.ODDCampaignID, campQuestionnaireToCreate).then(function () {
                $scope.$hide();
                $state.reload();
            });
        }
    }
})();